import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { SentFaxDetailDrawer, SentFaxPageInfo } from './types';

export const sentFaxPageInfoState = atom<SentFaxPageInfo>({
  page: 1,
  totalPage: 1,
  totalCount: 0,
  perPage: 25,
  date: new Date(),
  searchWord: null,
});

export const sentFaxDetailDrawerState = atomWithReset<SentFaxDetailDrawer>({
  isOpen: false,
  faximoSendFaxId: null,
});
